export interface FeedItem {
  id: string;
  tag: string;
  time: string;
  title: string;
  summary: string;
  count: string;
  img?: string;
}

export const navLinks = [
  { label: '今日速递', href: '#today' },
  { label: '素材流', href: '#feed' },
  { label: '素材库', href: '#archive' },
  { label: '时间线', href: '#timeline' },
  { label: '热度榜', href: '#rank' },
  { label: '线索库', href: '#lead' },
];

export const tickerItems = [
  '#247 门店事件 47 屏聊天记录整理完成，已按时间重排归档',
  '#248 新增 4 张后台截图，导出时间戳与事件时间线吻合',
  '#249 第二段通话文字稿出稿，正在核对实名指认段落',
  '新线索：供应商送货单日期，与爆料时间线形成闭环',
  '#250 招募群聊记录补全，含两处关键改口',
  '素材复核：1 张旧图被标记「重复引用」，已移出证据链',
];

export const heroStat = [
  { label: '已入库素材', value: '1,283' },
  { label: '正在跟进事件', value: '37' },
  { label: '今日新增', value: '54' },
];

export const heroTags = [
  '48 屏记录',
  '2 段录音',
  '17 张截图',
  '已核验 3 项',
];

export const latestFeed: FeedItem[] = [
  {
    id: 'F1',
    tag: '事件时间线更新',
    time: '09.06 20:14',
    title: '「门店事件」关键一夜：从内部群抱怨到公开对质的完整经过',
    summary:
      '我们把散落在 6 个渠道的 47 屏聊天记录、9 段语音与后台流水拼回了同一条线。本文用编号对应每一屏记录，关键改口处单独标注，方便你顺着时间线还原事件全貌。',
    count: '47 屏 / 12 处关键节点',
    img: 'https://readdy.ai/api/search-image?query=archival%20case%20file%20folder%20with%20stacked%20typed%20documents%20and%20paper%20clips%20on%20warm%20wooden%20desk%2C%20soft%20natural%20window%20light%2C%20muted%20warm%20tones%2C%20documentary%20investigation%20mood%2C%20editorial%20photography&width=1200&height=760&seq=feed-featured-52b&orientation=landscape',
  },
  {
    id: 'F2',
    tag: '聊天记录新增',
    time: '09.06 18:32',
    title: '招募群 12 页改口记录流出，两处表述前后矛盾',
    summary: '同一 ID 在「报价」与「到货」两个阶段给出不同口径，全文已标注比对。',
    count: '12 页 / 改口 2 处',
  },
  {
    id: 'F3',
    tag: '截图补充',
    time: '09.06 16:05',
    title: '后台导出截图 4 张，指向同一管理员操作时段',
    summary: '操作日志与截图留痕互为佐证，时间戳连贯，无明显剪辑痕迹。',
    count: '4 张 / 同源导出',
  },
  {
    id: 'F4',
    tag: '旁证线索',
    time: '09.06 13:47',
    title: '供应商送货单浮出，日期与爆料的「补货」说互相印证',
    summary: '单据抬头、日期、批号齐全，已与既有素材比对编号一致。',
    count: '1 份 / 编号一致',
  },
  {
    id: 'F5',
    tag: '通话文字稿',
    time: '09.05 22:10',
    title: '「代运营纠纷」第二段通话完成转写，重点指认段待核实',
    summary: '文字稿保留语气停顿与插话，标注「含推测表述」，供后续对照录音。',
    count: '18 分钟 / 3 处待核实',
  },
];

export interface MaterialType {
  key: string;
  name: string;
  desc: string;
  total: string;
  icon: string;
}

export const materialTypes: MaterialType[] = [
  { key: 'chat', name: '聊天记录', desc: '群聊、私聊逐屏归档，按事件与时间双重排序，改口处单独标注。', total: '486 屏', icon: 'ri-chat-3-line' },
  { key: 'shot', name: '截图留痕', desc: '后台、订单、支付与后台操作留痕，导出时间戳逐张比对。', total: '372 张', icon: 'ri-camera-line' },
  { key: 'clue', name: '线索旁证', desc: '录音文字稿、单据、送货与到货记录，用于补齐证据链闭环。', total: '425 条', icon: 'ri-focus-3-line' },
];

export interface MaterialItem {
  type: string;
  no: string;
  name: string;
  note: string;
  meta: string;
}

export const materialItems: MaterialItem[] = [
  { type: 'chat', no: 'C-0241', name: '内部群「报价 vs 实收」对账截图', note: '报价口径与到货口径不一致，改口处用红色标注。', meta: '12 屏 · 群聊' },
  { type: 'shot', no: 'S-0371', name: '后台管理员操作时段日志', note: '导出时间戳与爆料时间线吻合，未见剪辑痕迹。', meta: '4 张 · 后台' },
  { type: 'clue', no: 'L-0318', name: '供应商送货单（批号齐全）', note: '日期、抬头与补货说法互相印证，编号一致。', meta: '1 份 · 旁证' },
  { type: 'chat', no: 'C-0227', name: '招募群 12 页改口记录', note: '同一 ID 前后口径矛盾，已完成逐行标注。', meta: '12 屏 · 群聊' },
  { type: 'shot', no: 'S-0366', name: '支付流水到账留痕', note: '金额、到账时间与事件描述形成闭环。', meta: '6 张 · 支付' },
  { type: 'clue', no: 'L-0302', name: '第二段通话文字稿', note: '含「推测表述」标注，待与录音逐句复核。', meta: '18 分钟 · 音频' },
  { type: 'chat', no: 'C-0208', name: '「到货就转」私聊承诺截图', note: '关键承诺句单独裁出，附上下文 4 屏。', meta: '5 屏 · 私聊' },
  { type: 'clue', no: 'L-0295', name: '第三方核验记录', note: '3 项事实已由第三方渠道回访确认。', meta: '3 项 · 已核验' },
  { type: 'shot', no: 'S-0344', name: '商品详情页留存快照', note: '价格与活动文案分阶段留存，比对删改痕迹。', meta: '9 张 · 页面' },
];

export interface RankItem {
  no: number;
  name: string;
  heat: number;
  trend: 'up' | 'flat' | 'new';
}

export const hotRank: RankItem[] = [
  { no: 1, name: '「门店事件」内部群实录', heat: 9872, trend: 'up' },
  { no: 2, name: '「代运营纠纷」全额退款始末', heat: 8611, trend: 'new' },
  { no: 3, name: '「招聘平台」职位描述删改比对', heat: 7380, trend: 'up' },
  { no: 4, name: '「团购券」到店核销差异记录', heat: 6522, trend: 'flat' },
  { no: 5, name: '「品牌代拍」报价实付对不上', heat: 5940, trend: 'new' },
  { no: 6, name: '「小区物业」报修闭环缺失清单', heat: 4703, trend: 'flat' },
];

export interface TimelineNode {
  date: string;
  title: string;
  text: string;
  evidence: string;
  state: 'done' | 'verify' | 'open';
}

export const timelineNodes: TimelineNode[] = [
  { date: '09.01', title: '内部群首次出现抱怨', text: '「门店事件」相关记录最早出现在内部群，抱怨集中指向补货与到货口径。', evidence: 'C-0241 · 已入库', state: 'done' },
  { date: '09.03', title: '改口记录浮出', text: '招募群同一 ID 在报价与到货阶段给出不同口径，两处表述前后矛盾。', evidence: 'C-0227 · 已入库', state: 'done' },
  { date: '09.05', title: '后台留痕比对完成', text: '管理员操作日志与 4 张导出截图互为佐证，时间戳连贯。', evidence: 'S-0371 · 已入库', state: 'done' },
  { date: '09.06', title: '旁证送货单闭环', text: '供应商单据日期与「补货」说法互相印证，证据链基本闭环。', evidence: 'L-0318 · 已核验', state: 'verify' },
  { date: '待跟进', title: '公开对质前的最后缺口', text: '尚缺「实际到货」第三方佐证，相关方实名表述仍在复核。', evidence: '待补证', state: 'open' },
];

export interface LeadCard {
  title: string;
  body: string;
  from: string;
  state: '核实中' | '待收录' | '已闭环';
  time: string;
}

export const leads: LeadCard[] = [
  { title: '「到货但未对账」的仓库记录', body: '爆料人称有 3 条仓库出入库记录可佐证到货时间，正向其索取原始导出文件以比对时间戳。', from: '来自私信投稿', state: '核实中', time: '09.06' },
  { title: '同一批号的异地到货单', body: '另一渠道提供同批号送货单，疑似补货流向指向不同门店，需人工核验抬头归属。', from: '来自邮件投稿', state: '核实中', time: '09.05' },
  { title: '公开对质后的截图跟进', body: '对质帖发出后新增数屏截图，包含一段此前未出现的关键对话，等待与已知记录比对。', from: '来自评论区', state: '待收录', time: '09.06' },
];

export const keywords = [
  '聊天记录', '截图', '素材', '证据', '细节', '线索', '时间线', '改口', '对账', '还原', '旁证', '核实', '证据链', '留痕', '归档',
];